import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function TreinadorNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+do+Treinador+%E2%80%94+menu+superior+%E2%80%94+Quero+treinar+com+o+Treinador"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Quero Treinar com o Treinador
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+do+Treinador+%E2%80%94+menu+mobile+%E2%80%94+Quero+treinar+com+o+Treinador"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Quero Treinar com o Treinador
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function TreinadorPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const baseAtuacao = [
    'Teatro Escola Célia Helena',
    'Fátima Toledo',
    'Instituto Stanislavski'
  ];

  const jiujitsuBeneficios = [
    'Disciplina',
    'Foco',
    'Resiliência',
    'Estratégia',
    'Controle emocional',
    'Presença em situações de pressão'
  ];

  const metodologia = [
    'Leitura comportamental e emocional',
    'Macro e micro objetivos de ação',
    'Subtexto e verdade emocional',
    'Construção comportamental aplicada à cena e à vida',
    'Verbos de ação para execução real',
    'Preparação mental para performance e tomada de decisão',
    'Disciplina interna e foco extremo',
    'Energia aplicada à presença, voz e comportamento'
  ];

  const energiaAplicacoes = [
    'Comportamento',
    'Presença',
    'Estabilidade emocional',
    'Ritmo mental',
    'Tomada de decisão',
    'Comunicação',
    'Leitura humana',
    'Liderança',
    'Performance em palco, sala de aula, ambiente profissional ou esportivo'
  ];

  const telepatiaUsos = [
    'Leitura rápida de ambiente e pessoas',
    'Percepção de intenções e ritmos emocionais',
    'Sincronia com grupos',
    'Comunicação sutil e direcionamento vibratório',
    'Ajuste imediato da atenção e do foco'
  ];

  const preparacao = [
    'Acessar o Estado Zero',
    'Manter foco sob pressão',
    'Blindar o emocional',
    'Estruturar presença firme',
    'Sustentar verdade e clareza',
    'Agir com consistência, precisão e consciência'
  ];

  const metodoEntrega = [
    'Transformação rápida',
    'Clareza emocional e técnica',
    'Presença forte e consciente',
    'Domínio do estado interno',
    'Disciplina de execução',
    'Força de liderança',
    'Verdade humana e artística'
  ];

  const marcaTreinador = [
    'Didática objetiva e profunda',
    'Leitura emocional precisa',
    'Comunicação de alto impacto',
    'Pulso firme e direção clara',
    'Compreensão real do comportamento humano',
    'Capacidade de transformar pessoas rapidamente',
    'Disciplina marcial trazida do Jiu-Jitsu',
    'Condução estruturada, segura e profissional'
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <TreinadorNavbar />

      {/* Banner */}
      <div className="relative w-full h-[280px] sm:h-[320px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/f7611cff88c33e4d00e351e0bbc489b8.jpg"
          alt="Cláudio SAN — O Treinador"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            O Treinador
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Cláudio SAN
          </h1>
          <p className="text-sm sm:text-base text-white/90 mt-3 max-w-2xl">
            Treinador Metódico responsável pela construção, direção e condução da metodologia AAPEQ
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        {/* Introdução */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              Cláudio SAN é o Treinador Metódico responsável pela construção, direção e condução da metodologia AAPEQ.
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              Reconhecido pela precisão técnica, clareza emocional e capacidade de transformar pessoas rapidamente, ele atua desenvolvendo artistas, líderes, professores, coaches, atletas e profissionais que trabalham diretamente com pessoas e precisam performar em alto nível.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              Sua força está na integração entre técnica, comportamento, energia, comunicação, presença e disciplina, criando processos profundos, práticos e completamente aplicáveis à vida real.
            </p>
          </div>
        </section>

        {/* Base de Atuação */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-theatre-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Base de Atuação</h2>
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Ao longo de sua trajetória, Cláudio SAN desenvolveu uma base sólida e prática de atuação na relação da evolução do ser, trabalhando diretamente com pessoas reais e suas demandas emocionais, comportamentais e profissionais.
            </p>
            <p className="text-base text-gray-700 font-semibold mb-4">Sua formação técnica inclui:</p>
            <div className="space-y-3 mb-8">
              {baseAtuacao.map((item, index) => (
                <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-lg">
                  <span className="text-[#F05954] text-lg flex-shrink-0">✔</span>
                  <span className="text-sm font-medium text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-6 rounded-xl">
              <p className="text-base font-semibold mb-4">
                Além disso, Cláudio é faixa preta de Jiu-Jitsu, trazendo para sua metodologia:
              </p>
              <div className="grid sm:grid-cols-2 gap-3">
                {jiujitsuBeneficios.map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#F05954] flex-shrink-0"></span>
                    <span className="text-sm text-white">{item}</span>
                  </div>
                ))}
              </div>
              <p className="text-sm text-white/90 mt-6">
                Esse conjunto fortalece ainda mais sua abordagem como treinador, unindo técnica artística, comportamento humano e disciplina marcial.
              </p>
            </div>
          </div>
        </section>

        {/* Metodologia do Treinador */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-compass-3-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Metodologia do Treinador</h2>
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Unindo suas formações com sua experiência prática, Cláudio SAN estruturou uma metodologia que integra:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mb-6">
              {metodologia.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-base text-gray-700 font-semibold">
              Sua condução é marcada por objetividade, clareza, precisão técnica, firmeza e sensibilidade na leitura humana.
            </p>
          </div>
        </section>

        {/* Energia e Telepatia */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">A Energia e a Telepatia como Ferramenta Técnica</h2>
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Sem qualquer abordagem espiritual, Cláudio utiliza a energia e a telepatia como técnicas profissionais, aplicadas de forma objetiva para aprimorar:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {energiaAplicacoes.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="bg-white p-6 rounded-xl border-l-4 border-[#F05954] mb-6">
              <p className="text-base text-gray-700 font-semibold mb-4">
                A energia é tratada como gestão e organização do estado interno, enquanto a telepatia é utilizada como:
              </p>
              <div className="space-y-2">
                {telepatiaUsos.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                    <span className="text-sm text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <p className="text-base text-gray-700 font-semibold mb-4">
              Ele prepara seus treinandos para:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mb-6">
              {preparacao.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="bg-[#F05954] text-white p-5 rounded-xl">
              <p className="text-base font-semibold">
                Essa abordagem é moderna, objetiva, limpa e funcional, totalmente direcionada à performance humana.
              </p>
            </div>
          </div>
        </section>

        {/* Por Que Treinar */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-medal-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Por Que Treinar com Cláudio SAN?</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-6">Porque seu método entrega:</p>
            <div className="grid sm:grid-cols-2 gap-3">
              {metodoEntrega.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5 text-lg">✔</span>
                  <span className="text-sm font-medium text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-base text-gray-700 font-bold mt-8 text-center">
              É treinamento para quem quer evoluir na vida, na arte, no esporte e na liderança.
            </p>
          </div>
        </section>

        {/* A Marca do Treinador */}
        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">A Marca do Treinador</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-6">Cláudio SAN é reconhecido por:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {marcaTreinador.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-6 rounded-xl">
              <p className="text-base font-semibold">
                Ele forma indivíduos que atuam com verdade, força, presença e alta performance, dentro e fora do contexto artístico.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-4">
              Treine com o Treinador
            </h2>
            <p className="text-base text-gray-700 mb-8">
              Quer ser treinado diretamente por Cláudio SAN?<br />
              Participe da AAPEQ ou solicite processos exclusivos.
            </p>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+do+Treinador+%E2%80%94+CTA+final+%E2%80%94+Quero+treinar+com+o+Treinador"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Quero Treinar com o Treinador
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}